exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nav-production-enter .is-stu[data-v-75a66e8e]{font-size:16px}.nav-production-enter .tiny[data-v-75a66e8e]{font-size:12px}\n", ""]);

